import React, { useEffect, useState, useContext } from "react";
import AuthContext from "../../contexts/AuthContext";
import ApiCall from "../../utils/ApiCall";
import { LOP} from "../../Constants";
import { Loader, Table } from "../../components";

const LossOfPay = () => {
  const { authTokens } = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState(true);
  const [lopData, setLopData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ SAME PAGINATION AS MODIFY USER
  const [currentPage, setCurrentPage] = useState(1);
  const rowPerPage = 7;

  useEffect(() => {
    fetchData();
  }, []);

  // 🔹 Fetch Data
  const fetchData = async () => {
    try {
      const res = await ApiCall(
        LOP,
        "GET",
        authTokens,
        null
      );

      // ✅ Filter only lop > 0
      const filtered = (res.data || []).filter(
        (item) => Number(item.lop) > 0
      );

      setLopData(filtered);
      setIsLoading(false);
    } catch (error) {
      console.log("Error fetching LOP data", error);
      setIsLoading(false);
    }
  };

  // 🔹 Search Filter (by user_id)
  const filteredData = lopData.filter((item) =>
    item.user_id?.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );

  // 🔹 Pagination handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="w-auto my-6 flex flex-col mx-6 py-4 px-2">
      <h2 className="text-lg font-semibold mb-4 text-white">
        Loss of Pay (LOP)
      </h2>

      {/* 🔹 Search */}
      <div className="flex justify-end mb-4 px-2">
        <input
          type="text"
          placeholder="Search by User ID..."
          className="px-4 py-2 rounded-lg bg-transparent border border-gray-500 text-white outline-none w-64"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      {/* 🔹 Table */}
      {isLoading ? (
        <div className="w-full h-[60vh] flex items-center justify-center">
          <Loader />
        </div>
      ) : (
        <Table
          header={[
            "User ID",
            "Sick Leave",
            "Casual Leave",
            "Leave Applied",
            "Granted Leave",
            "LOP",
          ]}
          body={filteredData.map((row) => [
            row.user_id || "-",
            row.sick_leave || 0,
            row.casual_leave || 0,
            row.leave_applied || 0,
            row.granted_leave || 0,
            row.lop || 0,
          ])}
          paginationNeed={true}
          currentPage={currentPage}
          rowPerPage={rowPerPage}
          paginationBody={filteredData}
          onPageChange={handlePageChange}
          tableStyle="intro-x"
        />
      )}
    </div>
  );
};

export default LossOfPay;